export default "__VITE_ASSET__BiAOhzbX__"